import axios from 'axios';
import BASE_URL from '../config/apiConfig';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
  baseURL: `${BASE_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000, // 60 seconds timeout
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Add response interceptor to handle timeout errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
      const timeoutError = new Error(
        'Request timeout. The server is taking too long to respond. Please try again.',
      );
      timeoutError.isTimeout = true;
      return Promise.reject(timeoutError);
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
